import { render, staticRenderFns } from "./DiscountField.vue?vue&type=template&id=1dd79138"
import script from "./DiscountField.vue?vue&type=script&lang=js"
export * from "./DiscountField.vue?vue&type=script&lang=js"
import style0 from "./DiscountField.vue?vue&type=style&index=0&id=1dd79138&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports